var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRed2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 3,
    width: 58,
    height: 58,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11111 0H56.8889C58.7749 0 60.5836 0.749204 61.9172 2.0828C63.2508 3.41639 64 5.22513 64 7.11111V56.8889C64 58.7749 63.2508 60.5836 61.9172 61.9172C60.5836 63.2508 58.7749 64 56.8889 64H7.11111C5.22513 64 3.41639 63.2508 2.0828 61.9172C0.749204 60.5836 0 58.7749 0 56.8889V7.11111C0 5.22513 0.749204 3.41639 2.0828 2.0828C3.41639 0.749204 5.22513 0 7.11111 0ZM14.2222 7.11111C12.3362 7.11111 10.5275 7.86032 9.19391 9.19391C7.86032 10.5275 7.11111 12.3362 7.11111 14.2222C7.11111 16.1082 7.86032 17.9169 9.19391 19.2505C10.5275 20.5841 12.3362 21.3333 14.2222 21.3333C16.1082 21.3333 17.9169 20.5841 19.2505 19.2505C20.5841 17.9169 21.3333 16.1082 21.3333 14.2222C21.3333 12.3362 20.5841 10.5275 19.2505 9.19391C17.9169 7.86032 16.1082 7.11111 14.2222 7.11111ZM49.7778 42.6667C47.8918 42.6667 46.0831 43.4159 44.7495 44.7495C43.4159 46.0831 42.6667 47.8918 42.6667 49.7778C42.6667 51.6638 43.4159 53.4725 44.7495 54.8061C46.0831 56.1397 47.8918 56.8889 49.7778 56.8889C51.6638 56.8889 53.4725 56.1397 54.8061 54.8061C56.1397 53.4725 56.8889 51.6638 56.8889 49.7778C56.8889 47.8918 56.1397 46.0831 54.8061 44.7495C53.4725 43.4159 51.6638 42.6667 49.7778 42.6667Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRed2);
export default __webpack_public_path__ + "static/media/red2.95a50077f829239d72872dda58c124a6.svg";
export { ForwardRef as ReactComponent };